(function($, undefined) {

$.nette.ext({
	before: function (xhr, settings) {
		if (!settings.nette) {
			return;
		}

		var question = settings.nette.el.data('confirm');
		if (question) {
			return confirm(question);
		}
	}
});

})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./node_modules/nette.ajax.js/extensions/confirm.ajax.js
// module id = 108
// module chunks = 0 1 2